<div class="varstvo-container">
  <h2>Prijavnica za Hotenjski športni teden</h2>
  <form [formGroup]="varstvoForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-column">
        <label for="name">Ime:</label>
        <input id="name" type="text" formControlName="name" required />

        <label for="yearOfBirth">Leto rojstva:</label>
        <input id="yearOfBirth" type="number" formControlName="yearOfBirth" required min="1920" />

        <label for="sex">Spol:</label>
        <select id="sex" formControlName="sex">
          <option value="Moški">M</option>
          <option value="Ženska">Ž</option>
        </select>

        <label for="address">Naslov:</label>
        <input id="address" type="text" formControlName="address" required />

        <label for="gradeInSchool">Razred v šoli v tekočem letu:</label>
        <input id="gradeInSchool" type="number" formControlName="gradeInSchool" required min="1" max="12" />
        <label>
          <input type="checkbox" formControlName="hotejeClub" /> Obiskuje treninge tekaških sekcij v ŠD Hotedršica
        </label>
  
        <label for="allergies">Zdravstvene in ostale posebnosti otroka (alergije, zdravila, prehrana…):</label>
        <textarea id="allergies" formControlName="allergies"></textarea>
      </div>

      <div class="form-column">
        <h3>Podatki o skrbnikih</h3>
        <div class="parent-info">
          <h4>Skrbnik 1</h4>
          <label for="parent1Name">Ime:</label>
          <input id="parent1Name" type="text" formControlName="parent1Name" />
          <label for="parent1Address">Naslov:</label>
          <input id="parent1Address" type="text" formControlName="parent1Address" />
          <label for="parent1Phone">Telefon:</label>
          <input id="parent1Phone" type="text" formControlName="parent1Phone" />
          <label for="parent1Email">Email:</label>
          <input id="parent1Email" type="email" formControlName="parent1Email" />
        </div>

        <div class="parent-info">
          <h4>Skrbnik 2 (zaželjeno)</h4>
          <label for="parent2Name">Ime:</label>
          <input id="parent2Name" type="text" formControlName="parent2Name" />
          <label for="parent2Address">Naslov:</label>
          <input id="parent2Address" type="text" formControlName="parent2Address" />
          <label for="parent2Phone">Telefon:</label>
          <input id="parent2Phone" type="text" formControlName="parent2Phone" />
          <label for="parent2Email">Email:</label>
          <input id="parent2Email" type="email" formControlName="parent2Email" />
        </div>

      </div>
    </div>

    <button type="submit" [disabled]="!varstvoForm.valid">Pošlji prijavo</button>
  </form>
  <div *ngIf="isOrgAdmin" class="container mt-5">
    <h3>Seznam prijavljenih otrok</h3>
    <p>Število prijavljenih: {{ kids.length }}</p>
  
    <!-- Make the table responsive -->
    <div class="table-responsive">
      <table *ngIf="kids.length > 0" class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Ime</th>
            <th>Leto rojstva</th>
            <th>Spol</th>
            <th>Naslov</th>
            <th>Razred</th>
            <th>Skrbnik 1</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Skrbnik 2</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Trening v ŠD Hotedršica</th>
            <th>Zdravstvene posebnosti</th>
            <th>Čas prijave</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let login of kids">
            <td>{{ login.name }}</td>
            <td>{{ login.yearOfBirth }}</td>
            <td>{{ login.sex }}</td>
            <td>{{ login.address }}</td>
            <td>{{ login.gradeInSchool }}</td>
            <td>{{ login.parent1Name }}</td>
            <td>{{ login.parent1Phone }}</td>
            <td>{{ login.parent1Email }}</td>
            <td>{{ login.parent2Name }}</td>
            <td>{{ login.parent2Phone }}</td>
            <td>{{ login.parent2Email }}</td>
            <td>{{ login.hotejeClub ? 'Da' : 'Ne' }}</td>
            <td>{{ login.allergies }}</td>
            <td>{{ login.timeStamp }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <p *ngIf="kids.length === 0">Ni še registriranih otrok.</p>
    <button (click)="downloadCSV()">Naloži CSV</button>
  </div>
  
